// src/components/Transactions.jsx
import React, { useEffect, useState } from "react";
import "./Transactions.css";
import { supabase } from "../supabaseClient";
import { useAuth } from "../contexts/SupabaseAuthProvider";

export default function Transactions() {
  const { user } = useAuth();
  const [list, setList] = useState([]);

  const safeArray = (arr) => {
    if (!arr) return [];
    if (!Array.isArray(arr)) return [];
    return arr.filter((x) => x && typeof x === "object");
  };

  const load = async () => {
    if (!user?.id) return;

    try {
      const { data, error } = await supabase
        .from("users_data")
        .select("transactions")
        .eq("user_id", user.id)
        .single();

      if (error) {
        console.log("transactions load error:", error);
        setList([]);
        return;
      }

      const arr = safeArray(data?.transactions);
      // sort newest first — handle time as ISO or number
      arr.sort((a, b) => {
        const ta = a?.time ? new Date(a.time).getTime() : 0;
        const tb = b?.time ? new Date(b.time).getTime() : 0;
        return tb - ta;
      });

      setList(arr);
    } catch (err) {
      console.error("load tx err:", err);
      setList([]);
    }
  };

  useEffect(() => {
    load();
  }, [user?.id]);

  useEffect(() => {
    if (!user?.id) return;
    const ch = supabase
      .channel("tx_rt")
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "users_data",
          filter: `user_id=eq.${user.id}`,
        },
        () => load()
      )
      .subscribe();

    return () => supabase.removeChannel(ch);
  }, [user?.id]);

  const formatTime = (t) => {
    if (!t) return "Invalid";
    try {
      return new Date(t).toLocaleString();
    } catch {
      return "Invalid";
    }
  };

  return (
    <div className="tx-root">
      <div className="tx-card">
        <h2 className="tx-title">Transactions</h2>

        {list.length === 0 ? (
          <p className="tx-empty">No transactions yet</p>
        ) : (
          <div className="tx-list">
            {list.map((t, i) => (
              <div className="tx-item" key={t.id || i}>
                <div className="tx-left">
                  <div className="tx-type">
                    {t.type === "deposit" ? "Deposit" : "Payout"}
                  </div>
                  <div className="tx-net">{t.network || "N/A"}</div>
                  <div className="tx-time">{formatTime(t.time)}</div>
                </div>

                <div
                  className={
                    t.type === "deposit" ? "tx-amount green" : "tx-amount red"
                  }
                >
                  {t.type === "deposit" ? "+" : "-"}${Number(t.amount || 0)}
                </div>

                <div
                  className={
                    t.status === "success"
                      ? "tx-status success"
                      : t.status === "pending"
                      ? "tx-status pending"
                      : "tx-status failed"
                  }
                >
                  {t.status ? t.status.charAt(0).toUpperCase() + t.status.slice(1) : "Pending"}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
